export default [
  {
    path: '/role',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'roleList',
        component: () => import('./containers/RoleListContainer'),
      },
    ],
  },
]
